module.exports = __webpack_public_path__ + "static/2front-hasta-1-4d8ef223f4c388560b21e79a91eeed3c.png";